import React, {useState, useEffect} from 'react'
import {FiUpload} from 'react-icons/fi';

import './styles.css';

interface Props {
    onFileUploaded: (file: File) => void;
    selectedFile: File | undefined;
    currentUrl: string;
    mode: string
}

const Dropzone: React.FC<Props> = ({onFileUploaded, selectedFile, currentUrl, mode}) => {
    const [selectedFileUrl, setSelectedFilesUrl] = useState('');

    useEffect(() => {
        currentUrl && setSelectedFilesUrl(currentUrl);
    }, [currentUrl]);


    const getCurrentImage = () => {
        if (selectedFile) {
            return (
                <React.Fragment>
                    A imagem carregada será exibida assim
                    <img src={URL.createObjectURL(selectedFile)} className="circle" alt={'Imagem anexada'} width={120}
                         height={120}/>
                </React.Fragment>
            );
        } else {
            if (mode === 'edit') {
                return (
                    <img src={selectedFileUrl} className="circle" alt={'Imagem salva'} width={120}
                         height={120}/>
                );
            }
        }
    }

    return (
        <div className="field">
            <label htmlFor="image-upload" className="custom-file-upload">
                Selecione o ícone da história <FiUpload/>
            </label>
            <input type="file" id="image-upload" accept="image/*" onChange={(e) => {
                if (e.target.files) {
                    onFileUploaded(e.target.files[0])
                }
            }}/>
            <div style={{justifyContent: 'center', alignItems: 'center', flexDirection: 'column', display: 'flex'}}>
                {getCurrentImage()}
            </div>
        </div>
    );
}

export default Dropzone;
